import { combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { ModalsService } from '@core/services/modals/modals.service';

import { CartCommentLabels } from '@config/labels/comment.labels';
import { CartCommentTypeValues } from '@config/values/cart.values';
import { ModalScrollBlockBase } from '@core/base/modalScrollBlock/modal-scroll-block.base';

import { CartStoreSelector } from '@common/selectors/cart.selector';
import { ModalStoreSelector } from '@common/selectors/modal.selector';
import { CartStoreDispatcher } from '@common/dispatchers/cart.dispatcher';
import { SettingsStoreSelector } from '@common/selectors/settings.selector';

@Component({
  selector: 'app-cart-comment-modal',
  templateUrl: './cart-comment-modal.component.html',
  standalone: false,
})
export class CartCommentModalComponent extends ModalScrollBlockBase implements OnInit, OnDestroy {
  static handle = 'cart-comment-modal';

  index$ = this.modalSelector
    .selectModal(CartCommentModalComponent.handle)
    .pipe(map(el => (el?.index ? el.index : 4)));

  title!: string;

  message?: string | null;

  isMobileScreen = false;

  constructor(
    private cartSelector: CartStoreSelector,
    private modalSelector: ModalStoreSelector,
    private cartDispatcher: CartStoreDispatcher,
    private readonly modalsService: ModalsService,
    readonly settingsSelector: SettingsStoreSelector,
  ) {
    super();
  }

  ngOnInit(): void {
    combineLatest([
      this.cartSelector.selectComment.pipe(map(c => c?.type)),
      this.cartSelector.selectActive$,
    ])
      .pipe(
        take(1),
        map(([type, cart]) => {
          if (type === CartCommentTypeValues.Merchant) {
            this.title = CartCommentLabels.Merchant;
            this.message = cart?.message;
          }
        }),
      )
      .subscribe();

    // Track mobile screen state for keyboard offset handling
    this.settingsSelector.selectDeviceIsMobileScreen.subscribe(isMobile => {
      this.isMobileScreen = isMobile;
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  applyComment(comment: string): void {
    const commentType = this.cartSelector.state.comment?.type;
    if (comment && commentType === CartCommentTypeValues.Merchant) {
      this.cartDispatcher.updateActive({ message: comment });
    }
    this.closeComment();
  }

  closeComment(): void {
    this.modalsService.close(CartCommentModalComponent.handle);
  }

  // Only apply keyboard offset on mobile screens
  get mobileKeyboardOffset(): number | undefined {
    return this.isMobileScreen ? this.keyboardOffset : undefined;
  }
}
